import { render, staticRenderFns } from "./SacAdmin.vue?vue&type=template&id=33215be3"
import script from "./SacAdmin.vue?vue&type=script&lang=js"
export * from "./SacAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports